import moment from 'moment'
import { initialFormState } from './helpers'

const DEFAULT_PEBBLE_DETAILS_CREW_INFORMATION_STATE = [
    {id: -1, phase_type: {id: 1, name: 'Prep'}, status: {id: 2, name: 'Pending'}},
    {id: -1, phase_type: {id: 2, name: 'App'}, status: {id: 2, name: 'Pending'}},
    {id: -1, phase_type: {id: 3, name: 'Detail'}, status: {id: 2, name: 'Pending'}},
    {id: -1, phase_type: {id: 5, name: 'Slurry'}, status: {id: 2, name: 'Pending'}}
]

const DEFAULT_GUNITE_HISTORY_STATE = [
    {id: -1, type: {id: 1, name: "Day 1" } }
]
export const DEFAULT_JOB_DETAIL_STATE = {
    job_types: [],
    is_cash_on_delivery: false,
    is_in_print_queue: false,
    is_critical_note: false,
    is_invoiced: false,
    pebble_details: {
        is_request_form: false,
        is_slurry_pickup: false,
        is_can_show: false,
        is_complete_chip_out: false,
        is_update_channel_drain: false,
        is_trim_tile: false,
        is_trash_pick_up: false,
        color_additions: [],
        crew_information: DEFAULT_PEBBLE_DETAILS_CREW_INFORMATION_STATE,
        request_date: moment().format('YYYY-MM-DD'),
        is_no_prep_print: false
    },
    gunite_details: {
        is_spa_negative_edge: false,
        is_spa_rolled_edge: false,
        is_flash: false,
        gunite_history: DEFAULT_GUNITE_HISTORY_STATE
    },
    boulder_details: [],
    warranty_details: {
        is_gunite_division: false,
        is_pebble_division: false,
        is_boulder_creations_division: false,
        is_will_need_to_return: false,
        pool_sections: [],
        pebble_details: [],
        schedule: [],
        creation_date: moment().format('YYYY-MM-DD'),
        crew_repair_jobs:[]
    },
    presite: {
        is_bond_cote: false,
        is_complete_chip_out: false,
        is_weeping: false,
        install_trim_tile_mosaics: false,
        comments: [],
        is_water_on_site: false,
        is_access_to_power: false,
        is_pool_ready_to_shoot: false,
        is_job_caved_in: false,
        is_needs_inspection: false,
        is_steel_done: false,
        is_stub_out: false,
        is_depth_matches_plan: false
    }
}

export const DEFAULT_JOB_STATE = {
    is_central_texas: false,
    is_display: false,
    is_commercial: false,
    is_estimate: false,
    was_estimated: false,
    state: initialFormState,
    sub_jobs: [
        DEFAULT_JOB_DETAIL_STATE
    ]
}
